import { isValidNumber } from 'libphonenumber-js'
import { AjvError } from 'react-jsonschema-form'

type PatternType = RegExp | ((input: string) => boolean)

const patterns = {
  ALPHANUMERIC: /^[a-zA-Z0-9]+$/,
  EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
}

export const formats: { [format: string]: { message: string; pattern: PatternType } } = {
  email: {
    message: 'You have entered an invalid email address. Please try again.',
    pattern: patterns.EMAIL,
  },
  passport: {
    message: 'You have entered an invalid passport number. Please try again.',
    pattern: patterns.ALPHANUMERIC,
  },
  phone: {
    message: 'You have entered an invalid phone number. Please try again.',
    pattern: input => isValidNumber(input),
  },
}

export const formatPatterns = Object.keys(formats).reduce<{ [format: string]: PatternType }>(
  (acc, format) => {
    acc[format] = formats[format].pattern
    return acc
  },
  {}
)

export const transformErrors = (errors: AjvError[]) =>
  errors.map(error => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const format = formats[error.params.format]
    if (!format) return error

    return { ...error, message: format.message }
  })
